export const filterBySaleType = saleType => option => {
  if (option.saleTypes) {
    return option.saleTypes.includes(saleType);
  } else {
    return true;
  }
};
